import {ModelFactory} from '@shared/factories/model.factory';
import {DocumentTemplateTypeType} from '@generated/graphql';
import {DocumentTemplateType} from "@modules/document-template/models/document-template-type.model";

export class DocumentTemplateTypeFactory extends ModelFactory<DocumentTemplateTypeType, DocumentTemplateType> {
  create(state: DocumentTemplateType): DocumentTemplateType {
    return new DocumentTemplateType(state);
  }
}

export const documentTemplateTypeFactory = new DocumentTemplateTypeFactory();
